/* eslint-disable */
import { DocumentNode } from 'graphql';
import * as Urql from '@urql/vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  EmailAddress: { input: string; output: string; }
  JSON: { input: string; output: string; }
  RepeaterInstance: { input: any; output: any; }
  URL: { input: string; output: string; }
};

/**
 * Definition of Act as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Act = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Act.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<ActVariants>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  menuTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  scenes?: Maybe<Array<Maybe<Scalars['RepeaterInstance']['output']>>>;
  title: Scalars['String']['output'];
};


/**
 * Definition of Act as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type ActScenesArgs = {
  referenceResolutionStrategy?: InputMaybe<RepeaterReferenceResolutionStrategy>;
};

/** Input fields necessary to Create a Act */
export type ActCreateInput = {
  /**
   * Optional fields variants for Act.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<ActVariantsInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  scenes?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to Act. */
export enum ActFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering Act. */
export type ActFilterOptions = {
  field?: InputMaybe<ActFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort Act */
export enum ActSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a Act */
export type ActUpdateInput = {
  /**
   * Optional fields variants for Act.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<ActVariantsInput>;
  /** undefined */
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  scenes?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Act */
export type ActVariant = {
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  menuTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  scenes?: Maybe<Array<Maybe<Scalars['RepeaterInstance']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Definition of a possible variant for Act */
export type ActVariantScenesArgs = {
  referenceResolutionStrategy?: InputMaybe<RepeaterReferenceResolutionStrategy>;
};

/** Definition of the input for a possible variant for Act */
export type ActVariantInput = {
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  menuTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  scenes?: InputMaybe<Array<InputMaybe<Scalars['RepeaterInstance']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Act.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum ActVariantSelection {
  Base = 'base',
  De = 'de',
  Es = 'es',
  Fr = 'fr',
  It = 'it'
}

/** All variants for Act with their name as key. */
export type ActVariants = {
  /** A variant de for Act */
  de?: Maybe<ActVariant>;
  /** A variant es for Act */
  es?: Maybe<ActVariant>;
  /** A variant fr for Act */
  fr?: Maybe<ActVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for Act */
  it?: Maybe<ActVariant>;
};

/** Input fields necessary to Create or Update a Variants for Act */
export type ActVariantsInput = {
  /** Input fields necessary to Create or Update the variant de for Act */
  de?: InputMaybe<ActVariantInput>;
  /** Input fields necessary to Create or Update the variant es for Act */
  es?: InputMaybe<ActVariantInput>;
  /** Input fields necessary to Create or Update the variant fr for Act */
  fr?: InputMaybe<ActVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for Act */
  it?: InputMaybe<ActVariantInput>;
};

/** Possible ways to request Act in a Get query using the where parameter */
export enum ActWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type ActWhereParameter = {
  field?: InputMaybe<ActWhereOptions>;
  value: Scalars['String']['input'];
};

export enum ContentStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum FilterOperator {
  BeginsWith = 'beginsWith',
  Between = 'between',
  Eq = 'eq',
  Ge = 'ge',
  Gt = 'gt',
  Le = 'le',
  Lt = 'lt'
}

/**
 * Definition of HomePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type HomePage = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for HomePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<HomePageVariants>;
  /** undefined */
  acts?: Maybe<Array<Maybe<Act>>>;
  /** undefined */
  homeRedirect?: Maybe<HomePageHomeRedirect>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  introStartDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introStartLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introStartTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introTutorialOverline?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introTutorialTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  languageSwitcherCountry?: Maybe<Scalars['String']['output']>;
  /** undefined */
  languageSwitcherShipping?: Maybe<Scalars['String']['output']>;
  /** undefined */
  languageSwitcherTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  menuActLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  menuProductsRedirect?: Maybe<HomePageMenuProductsRedirect>;
  /** undefined */
  ogDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  ogTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  outroLink?: Maybe<HomePageOutroLink>;
  /** undefined */
  outroRestartLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  outroSubtitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  outroTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  products?: Maybe<Array<Maybe<Product>>>;
  /** undefined */
  productsCTA?: Maybe<Scalars['String']['output']>;
  /** undefined */
  productsSubtitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  productsTitle?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  shareImg?: Maybe<MediaFile>;
  /** undefined */
  teaserDate?: Maybe<Scalars['String']['output']>;
  /** undefined */
  teaserDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  teaserEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** undefined */
  teaserTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


/**
 * Definition of HomePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type HomePageActsArgs = {
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ActVariantSelection>>>;
};


/**
 * Definition of HomePage as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type HomePageProductsArgs = {
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantSelection>>>;
};

/** Input fields necessary to Create a HomePage */
export type HomePageCreateInput = {
  /**
   * Optional fields variants for HomePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<HomePageVariantsInput>;
  /** undefined */
  acts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  homeRedirect?: InputMaybe<HomePageHomeRedirectCreateInput>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introStartDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introStartLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introStartTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTutorialOverline?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTutorialTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherCountry?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherShipping?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  menuActLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  menuProductsRedirect?: InputMaybe<HomePageMenuProductsRedirectCreateInput>;
  /** undefined */
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroLink?: InputMaybe<HomePageOutroLinkCreateInput>;
  /** undefined */
  outroRestartLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  productsCTA?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  productsSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  productsTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  shareImg?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserDate?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** undefined */
  teaserTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to HomePage. */
export enum HomePageFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering HomePage. */
export type HomePageFilterOptions = {
  field?: InputMaybe<HomePageFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

export type HomePageHomeRedirect = {
  id?: Maybe<Scalars['ID']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HomePageHomeRedirectCreateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageHomeRedirectUpdateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageMenuProductsRedirect = {
  id?: Maybe<Scalars['ID']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HomePageMenuProductsRedirectCreateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageMenuProductsRedirectUpdateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageOutroLink = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type HomePageOutroLinkCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageOutroLinkUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Possible ways to sort HomePage */
export enum HomePageSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a HomePage */
export type HomePageUpdateInput = {
  /**
   * Optional fields variants for HomePage.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<HomePageVariantsInput>;
  /** undefined */
  acts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  homeRedirect?: InputMaybe<HomePageHomeRedirectUpdateInput>;
  /** undefined */
  introStartDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introStartLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introStartTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTutorialOverline?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTutorialTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherCountry?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherShipping?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  menuActLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  menuProductsRedirect?: InputMaybe<HomePageMenuProductsRedirectUpdateInput>;
  /** undefined */
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroLink?: InputMaybe<HomePageOutroLinkUpdateInput>;
  /** undefined */
  outroRestartLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  productsCTA?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  productsSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  productsTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  shareImg?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserDate?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** undefined */
  teaserTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for HomePage */
export type HomePageVariant = {
  /** undefined */
  acts?: Maybe<Array<Maybe<Act>>>;
  /** undefined */
  homeRedirect?: Maybe<HomePageVariantHomeRedirect>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  introStartDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introStartLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introStartTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introTutorialOverline?: Maybe<Scalars['String']['output']>;
  /** undefined */
  introTutorialTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  languageSwitcherCountry?: Maybe<Scalars['String']['output']>;
  /** undefined */
  languageSwitcherShipping?: Maybe<Scalars['String']['output']>;
  /** undefined */
  languageSwitcherTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  menuActLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  menuProductsRedirect?: Maybe<HomePageVariantMenuProductsRedirect>;
  /** undefined */
  ogDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  ogTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  outroLink?: Maybe<HomePageVariantOutroLink>;
  /** undefined */
  outroRestartLabel?: Maybe<Scalars['String']['output']>;
  /** undefined */
  outroSubtitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  outroTitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  products?: Maybe<Array<Maybe<Product>>>;
  /** undefined */
  productsCTA?: Maybe<Scalars['String']['output']>;
  /** undefined */
  productsSubtitle?: Maybe<Scalars['String']['output']>;
  /** undefined */
  productsTitle?: Maybe<Scalars['String']['output']>;
  /**
   * undefined
   * Value must be image/*
   */
  shareImg?: Maybe<MediaFile>;
  /** undefined */
  teaserDate?: Maybe<Scalars['String']['output']>;
  /** undefined */
  teaserDescription?: Maybe<Scalars['String']['output']>;
  /** undefined */
  teaserEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** undefined */
  teaserTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Definition of a possible variant for HomePage */
export type HomePageVariantActsArgs = {
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ActVariantSelection>>>;
};


/** Definition of a possible variant for HomePage */
export type HomePageVariantProductsArgs = {
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantSelection>>>;
};

export type HomePageVariantHomeRedirect = {
  id?: Maybe<Scalars['ID']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HomePageVariantHomeRedirectCreateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageVariantHomeRedirectUpdateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of the input for a possible variant for HomePage */
export type HomePageVariantInput = {
  /** undefined */
  acts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  homeRedirect?: InputMaybe<HomePageVariantHomeRedirectUpdateInput>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  introStartDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introStartLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introStartTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTutorialOverline?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  introTutorialTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherCountry?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherShipping?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  languageSwitcherTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  menuActLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  menuProductsRedirect?: InputMaybe<HomePageVariantMenuProductsRedirectUpdateInput>;
  /** undefined */
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroLink?: InputMaybe<HomePageVariantOutroLinkUpdateInput>;
  /** undefined */
  outroRestartLabel?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  outroTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** undefined */
  productsCTA?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  productsSubtitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  productsTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * undefined
   *
   * Value must be image/*
   */
  shareImg?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserDate?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserDescription?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  teaserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** undefined */
  teaserTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageVariantMenuProductsRedirect = {
  id?: Maybe<Scalars['ID']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HomePageVariantMenuProductsRedirectCreateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageVariantMenuProductsRedirectUpdateInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageVariantOutroLink = {
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type HomePageVariantOutroLinkCreateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageVariantOutroLinkUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for HomePage.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum HomePageVariantSelection {
  Base = 'base',
  De = 'de',
  Es = 'es',
  Fr = 'fr',
  It = 'it'
}

/** All variants for HomePage with their name as key. */
export type HomePageVariants = {
  /** A variant de for HomePage */
  de?: Maybe<HomePageVariant>;
  /** A variant es for HomePage */
  es?: Maybe<HomePageVariant>;
  /** A variant fr for HomePage */
  fr?: Maybe<HomePageVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for HomePage */
  it?: Maybe<HomePageVariant>;
};

/** Input fields necessary to Create or Update a Variants for HomePage */
export type HomePageVariantsInput = {
  /** Input fields necessary to Create or Update the variant de for HomePage */
  de?: InputMaybe<HomePageVariantInput>;
  /** Input fields necessary to Create or Update the variant es for HomePage */
  es?: InputMaybe<HomePageVariantInput>;
  /** Input fields necessary to Create or Update the variant fr for HomePage */
  fr?: InputMaybe<HomePageVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for HomePage */
  it?: InputMaybe<HomePageVariantInput>;
};

/** Possible ways to request HomePage in a Get query using the where parameter */
export enum HomePageWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type HomePageWhereParameter = {
  field?: InputMaybe<HomePageWhereOptions>;
  value: Scalars['String']['input'];
};

/** List result of a Act list. */
export type ListActResult = {
  /** Cursor, pass this as parameter to ListAct in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Act items */
  items: Array<Maybe<Act>>;
  /** Total count of type Act in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a HomePage list. */
export type ListHomePageResult = {
  /** Cursor, pass this as parameter to ListHomePage in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of HomePage items */
  items: Array<Maybe<HomePage>>;
  /** Total count of type HomePage in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a MediaFile list. */
export type ListMediaFileResult = {
  /** Cursor, pass this as parameter to ListMediaFile in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of MediaFile items */
  items: Array<Maybe<MediaFile>>;
  /** Total count of type MediaFile in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a Product list. */
export type ListProductResult = {
  /** Cursor, pass this as parameter to ListProduct in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of Product items */
  items: Array<Maybe<Product>>;
  /** Total count of type Product in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/** List result of a User list. */
export type ListUserResult = {
  /** Cursor, pass this as parameter to ListUser in order to advance pagination, null if there is no next page. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Id of this result */
  id: Scalars['ID']['output'];
  /** List of User items */
  items: Array<Maybe<User>>;
  /** Total count of type User in storage, with no limits. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Definition of MediaFile as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: NOONE
 * Get DRAFT: NOONE
 * Get PUBLISHED: PUBLIC
 * List DRAFT: NOONE
 * List PUBLISHED: PUBLIC
 * Publish: NOONE
 * Unpublish: NOONE
 */
export type MediaFile = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for MediaFile.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<MediaFileVariants>;
  fileSize: Scalars['Float']['output'];
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  mimeType: Scalars['String']['output'];
  /** example.jpg */
  originalName: Scalars['String']['output'];
  /**
   * An object containing information for how to upload the image using a multipart post upload.
   * Requester must have appropriate MediaFile create access level
   */
  uploadSignedRequest?: Maybe<Scalars['JSON']['output']>;
};

/** Input fields necessary to Create a MediaFile */
export type MediaFileCreateInput = {
  /**
   * Optional fields variants for MediaFile.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<MediaFileVariantsInput>;
  fileSize: Scalars['Float']['input'];
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  /** example.jpg */
  originalName: Scalars['String']['input'];
};

/** Possible fields where a filter can be applied to MediaFile. */
export enum MediaFileFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  FileSize = 'fileSize',
  Id = 'id',
  MimeType = 'mimeType'
}

/** Options for filtering MediaFile. */
export type MediaFileFilterOptions = {
  field?: InputMaybe<MediaFileFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort MediaFile */
export enum MediaFileSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  FileSize = 'fileSize',
  Id = 'id',
  MimeType = 'mimeType'
}

/** Input fields necessary to Update a MediaFile */
export type MediaFileUpdateInput = {
  /**
   * Optional fields variants for MediaFile.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<MediaFileVariantsInput>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** example.jpg */
  originalName?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for MediaFile */
export type MediaFileVariant = {
  fileSize?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  /** example.jpg */
  originalName?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for MediaFile */
export type MediaFileVariantInput = {
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** example.jpg */
  originalName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for MediaFile.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum MediaFileVariantSelection {
  Base = 'base'
}

/** All variants for MediaFile with their name as key. */
export type MediaFileVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for MediaFile */
export type MediaFileVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request MediaFile in a Get query using the where parameter */
export enum MediaFileWhereOptions {
  ModifiedAt = '_modifiedAt',
  FileSize = 'fileSize',
  MimeType = 'mimeType'
}

export type MediaFileWhereParameter = {
  field?: InputMaybe<MediaFileWhereOptions>;
  value: Scalars['String']['input'];
};

export type Mutation = {
  /**
   * Creates a new Act.
   *
   * Status of the content will be set to DRAFT
   */
  CreateAct?: Maybe<Act>;
  /**
   * Creates a new HomePage.
   *
   * Status of the content will be set to DRAFT
   */
  CreateHomePage?: Maybe<HomePage>;
  /**
   * Creates a new MediaFile.
   *
   * Status of the content will be set to DRAFT
   */
  CreateMediaFile?: Maybe<MediaFile>;
  /**
   * Creates a new Product.
   *
   * Status of the content will be set to DRAFT
   */
  CreateProduct?: Maybe<Product>;
  /**
   * Creates a new User.
   *
   * Status of the content will be set to DRAFT
   */
  CreateUser?: Maybe<User>;
  /** Deletes a Act. */
  DeleteAct?: Maybe<Act>;
  /** Deletes a HomePage. */
  DeleteHomePage?: Maybe<HomePage>;
  /** Deletes a MediaFile. */
  DeleteMediaFile?: Maybe<MediaFile>;
  /** Deletes a Product. */
  DeleteProduct?: Maybe<Product>;
  /** Deletes a User. */
  DeleteUser?: Maybe<User>;
  /** Publishes a Act. */
  PublishAct?: Maybe<Act>;
  /** Publishes a HomePage. */
  PublishHomePage?: Maybe<HomePage>;
  /** Publishes a Product. */
  PublishProduct?: Maybe<Product>;
  /** Unpublishes a Act. */
  UnpublishAct?: Maybe<Act>;
  /** Unpublishes a HomePage. */
  UnpublishHomePage?: Maybe<HomePage>;
  /** Unpublishes a Product. */
  UnpublishProduct?: Maybe<Product>;
  /**
   * Updates a Act.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateAct?: Maybe<Act>;
  /**
   * Updates a HomePage.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateHomePage?: Maybe<HomePage>;
  /**
   * Updates a Product.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateProduct?: Maybe<Product>;
  /**
   * Updates a User.
   *
   * Status of the content will be set to DRAFT.
   *
   * UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
   */
  UpdateUser?: Maybe<User>;
};


export type MutationCreateActArgs = {
  input: ActCreateInput;
};


export type MutationCreateHomePageArgs = {
  input: HomePageCreateInput;
};


export type MutationCreateMediaFileArgs = {
  input: MediaFileCreateInput;
};


export type MutationCreateProductArgs = {
  input: ProductCreateInput;
};


export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


export type MutationDeleteActArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteHomePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteMediaFileArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteProductArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishActArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishHomePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishProductArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishActArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishHomePageArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpublishProductArgs = {
  id: Scalars['String']['input'];
  occHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateActArgs = {
  id: Scalars['String']['input'];
  input: ActUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateHomePageArgs = {
  id: Scalars['String']['input'];
  input: HomePageUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateProductArgs = {
  id: Scalars['String']['input'];
  input: ProductUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  input: UserUpdateInput;
  occHash?: InputMaybe<Scalars['String']['input']>;
  updateStrategy?: InputMaybe<UpdateStrategy>;
};

/**
 * Definition of Product as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: EDITOR
 * Delete: EDITOR
 * Update: EDITOR
 * Get DRAFT: EDITOR
 * Get PUBLISHED: PUBLIC
 * List DRAFT: EDITOR
 * List PUBLISHED: PUBLIC
 * Publish: EDITOR
 * Unpublish: EDITOR
 */
export type Product = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for Product.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<ProductVariants>;
  /** undefined */
  category?: Maybe<Scalars['String']['output']>;
  /** undefined */
  description?: Maybe<Scalars['String']['output']>;
  /** undefined */
  displayTitle?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  /** undefined */
  image?: Maybe<ProductImage>;
  /** undefined */
  range?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Input fields necessary to Create a Product */
export type ProductCreateInput = {
  /**
   * Optional fields variants for Product.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<ProductVariantsInput>;
  /** undefined */
  category?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  image?: InputMaybe<ProductImageCreateInput>;
  /** undefined */
  range?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to Product. */
export enum ProductFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering Product. */
export type ProductFilterOptions = {
  field?: InputMaybe<ProductFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

export type ProductImage = {
  alt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MediaFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProductImageCreateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
};

export type ProductImageUpdateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
};

/** Possible ways to sort Product */
export enum ProductSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a Product */
export type ProductUpdateInput = {
  /**
   * Optional fields variants for Product.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<ProductVariantsInput>;
  /** undefined */
  category?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  image?: InputMaybe<ProductImageUpdateInput>;
  /** undefined */
  range?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for Product */
export type ProductVariant = {
  /** undefined */
  category?: Maybe<Scalars['String']['output']>;
  /** undefined */
  description?: Maybe<Scalars['String']['output']>;
  /** undefined */
  displayTitle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** undefined */
  image?: Maybe<ProductVariantImage>;
  /** undefined */
  range?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** undefined */
  url?: Maybe<Scalars['URL']['output']>;
};

export type ProductVariantImage = {
  alt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<MediaFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProductVariantImageCreateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
};

export type ProductVariantImageUpdateInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of the input for a possible variant for Product */
export type ProductVariantInput = {
  /** undefined */
  category?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  description?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** undefined */
  image?: InputMaybe<ProductVariantImageUpdateInput>;
  /** undefined */
  range?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** undefined */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for Product.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum ProductVariantSelection {
  Base = 'base',
  De = 'de',
  Es = 'es',
  Fr = 'fr',
  It = 'it'
}

/** All variants for Product with their name as key. */
export type ProductVariants = {
  /** A variant de for Product */
  de?: Maybe<ProductVariant>;
  /** A variant es for Product */
  es?: Maybe<ProductVariant>;
  /** A variant fr for Product */
  fr?: Maybe<ProductVariant>;
  id?: Maybe<Scalars['ID']['output']>;
  /** A variant it for Product */
  it?: Maybe<ProductVariant>;
};

/** Input fields necessary to Create or Update a Variants for Product */
export type ProductVariantsInput = {
  /** Input fields necessary to Create or Update the variant de for Product */
  de?: InputMaybe<ProductVariantInput>;
  /** Input fields necessary to Create or Update the variant es for Product */
  es?: InputMaybe<ProductVariantInput>;
  /** Input fields necessary to Create or Update the variant fr for Product */
  fr?: InputMaybe<ProductVariantInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Input fields necessary to Create or Update the variant it for Product */
  it?: InputMaybe<ProductVariantInput>;
};

/** Possible ways to request Product in a Get query using the where parameter */
export enum ProductWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type ProductWhereParameter = {
  field?: InputMaybe<ProductWhereOptions>;
  value: Scalars['String']['input'];
};

export type Query = {
  /**
   * Gets specified Act using either slug or id (one of the two erguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetAct?: Maybe<Act>;
  /**
   * Gets specified HomePage using either slug or id (one of the two erguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetHomePage?: Maybe<HomePage>;
  /**
   * Gets specified MediaFile using either slug or id (one of the two erguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetMediaFile?: Maybe<MediaFile>;
  /**
   * Gets specified Product using either slug or id (one of the two erguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetProduct?: Maybe<Product>;
  /**
   * Gets specified User using either slug or id (one of the two erguments must be passed).
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  GetUser?: Maybe<User>;
  /**
   * Lists all Act.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListAct?: Maybe<ListActResult>;
  /**
   * Lists all HomePage.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListHomePage?: Maybe<ListHomePageResult>;
  /**
   * Lists all MediaFile.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListMediaFile?: Maybe<ListMediaFileResult>;
  /**
   * Lists all Product.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListProduct?: Maybe<ListProductResult>;
  /**
   * Lists all User.
   * Status is PUBLISHED by default if no explicit status is specified.
   * Variant is "base" by default if no explicit variant cascade is specified.
   */
  ListUser?: Maybe<ListUserResult>;
};


export type QueryGetActArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ActVariantSelection>>>;
  where?: InputMaybe<ActWhereParameter>;
};


export type QueryGetHomePageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>>>;
  where?: InputMaybe<HomePageWhereParameter>;
};


export type QueryGetMediaFileArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<MediaFileVariantSelection>>>;
  where?: InputMaybe<MediaFileWhereParameter>;
};


export type QueryGetProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantSelection>>>;
  where?: InputMaybe<ProductWhereParameter>;
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UserVariantSelection>>>;
  where?: InputMaybe<UserWhereParameter>;
};


export type QueryListActArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ActSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ActVariantSelection>>>;
};


export type QueryListHomePageArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<HomePageFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<HomePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>>>;
};


export type QueryListMediaFileArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MediaFileFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<MediaFileSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<MediaFileVariantSelection>>>;
};


export type QueryListProductArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProductFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ProductSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantSelection>>>;
};


export type QueryListUserArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserFilterOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<UserSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UserVariantSelection>>>;
};

/** An object containing information about who references this Content and/or how many references it has */
export type Referents = {
  ActReferents?: Maybe<ListActResult>;
  HomePageReferents?: Maybe<ListHomePageResult>;
  MediaFileReferents?: Maybe<ListMediaFileResult>;
  ProductReferents?: Maybe<ListProductResult>;
  UserReferents?: Maybe<ListUserResult>;
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  pointers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsActReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ActSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ActVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsHomePageReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<HomePageSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsMediaFileReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<MediaFileSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<MediaFileVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsProductReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<ProductSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ProductVariantSelection>>>;
};


/** An object containing information about who references this Content and/or how many references it has */
export type ReferentsUserReferentsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  descending?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortOn?: InputMaybe<UserSortOptions>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<UserVariantSelection>>>;
};

export enum RepeaterReferenceResolutionStrategy {
  Complete = 'COMPLETE',
  None = 'NONE',
  Simple = 'SIMPLE'
}

export enum UpdateStrategy {
  Assign = 'ASSIGN',
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

/**
 * Definition of User as specified by the Content Model
 *
 * This Type has the following Access Control Policy:
 *
 * Create: ADMIN
 * Delete: ADMIN
 * Update: CREATOR
 * Get DRAFT: NOONE
 * Get PUBLISHED: CREATOR
 * List DRAFT: NOONE
 * List PUBLISHED: EDITOR
 * Publish: NOONE
 * Unpublish: NOONE
 */
export type User = {
  /** Originally Created by */
  _author?: Maybe<Scalars['String']['output']>;
  /** Type of content, one of defined Content Models */
  _contentType: Scalars['String']['output'];
  /** Creation DateTime */
  _createdAt: Scalars['DateTime']['output'];
  /** Hash of the content, to be passed as occHash parameter in mutations */
  _hash: Scalars['String']['output'];
  /** This content is Published, it will remain published */
  _isPublished: Scalars['Boolean']['output'];
  /** This content has an updated version */
  _isUpdated: Scalars['Boolean']['output'];
  /** Last Modification DateTime */
  _modifiedAt: Scalars['DateTime']['output'];
  /** Last Modified by */
  _modifiedBy?: Maybe<Scalars['String']['output']>;
  /** An object containing information about who references this Content and/or how many references it has */
  _referents?: Maybe<Referents>;
  /** Slug of the content */
  _slug?: Maybe<Scalars['String']['output']>;
  /**
   * All Fields variants for User.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _variants?: Maybe<UserVariants>;
  disableInvitationEmail?: Maybe<Scalars['Boolean']['output']>;
  /** example@mono-grid.com */
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique ID of the Entry */
  id: Scalars['ID']['output'];
  userStatus?: Maybe<Scalars['String']['output']>;
};

/** Input fields necessary to Create a User */
export type UserCreateInput = {
  /**
   * Optional fields variants for User.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<UserVariantsInput>;
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** example@mono-grid.com */
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty */
  id?: InputMaybe<Scalars['String']['input']>;
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Possible fields where a filter can be applied to User. */
export enum UserFilterFields {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Options for filtering User. */
export type UserFilterOptions = {
  field?: InputMaybe<UserFilterFields>;
  operand?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<FilterOperator>;
};

/** Possible ways to sort User */
export enum UserSortOptions {
  ModifiedAt = '_modifiedAt',
  Slug = '_slug',
  Id = 'id'
}

/** Input fields necessary to Update a User */
export type UserUpdateInput = {
  /**
   * Optional fields variants for User.
   * Variants can be used to create localization or other types of variations of a single content.
   *
   * Field Variants always have a "base variant" where values will fallback
   * when a field's value for the requested variant is not found.
   */
  _slug?: InputMaybe<Scalars['String']['input']>;
  _variants?: InputMaybe<UserVariantsInput>;
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** example@mono-grid.com */
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Definition of a possible variant for User */
export type UserVariant = {
  disableInvitationEmail?: Maybe<Scalars['Boolean']['output']>;
  /** example@mono-grid.com */
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  userStatus?: Maybe<Scalars['String']['output']>;
};

/** Definition of the input for a possible variant for User */
export type UserVariantInput = {
  disableInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** example@mono-grid.com */
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** id for this variant */
  id?: InputMaybe<Scalars['ID']['input']>;
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Possible fields variants for User.
 *
 * Content created with this model can have 1 or more "variants" for each of its fields.
 * Variants can be used to create localization or other types of variations of a single content.
 *
 * Field Variants always have a "base variant" where values will fallback
 * when a field's value for the requested variant is not found.
 */
export enum UserVariantSelection {
  Base = 'base'
}

/** All variants for User with their name as key. */
export type UserVariants = {
  id?: Maybe<Scalars['ID']['output']>;
};

/** Input fields necessary to Create or Update a Variants for User */
export type UserVariantsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Possible ways to request User in a Get query using the where parameter */
export enum UserWhereOptions {
  ModifiedAt = '_modifiedAt'
}

export type UserWhereParameter = {
  field?: InputMaybe<UserWhereOptions>;
  value: Scalars['String']['input'];
};

export type GetActQueryVariables = Exact<{
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<ActVariantSelection>> | InputMaybe<ActVariantSelection>>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetActQuery = { act?: Maybe<Pick<Act, 'scenes' | 'id' | 'title' | 'menuTitle' | '_slug'>> };

export type GetGlobalSeoQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  getHomePageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>> | InputMaybe<HomePageVariantSelection>>;
}>;


export type GetGlobalSeoQuery = { seo?: Maybe<(
    Pick<HomePage, 'id' | 'ogDescription' | 'ogTitle'>
    & { shareImg?: Maybe<Pick<MediaFile, 'id' | 'metaData' | '_slug'>> }
  )> };

export type GetHomePageQueryVariables = Exact<{
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>> | InputMaybe<HomePageVariantSelection>>;
}>;


export type GetHomePageQuery = { page?: Maybe<(
    Pick<HomePage, 'menuActLabel' | 'id' | 'introStartDescription' | 'introStartLabel' | 'introStartTitle' | 'introTutorialOverline' | 'introTutorialTitle' | 'outroRestartLabel' | 'outroSubtitle' | 'outroTitle' | 'productsSubtitle' | 'productsTitle' | 'productsCTA' | 'teaserDate' | 'teaserDescription' | 'teaserEnabled' | 'teaserTitle' | 'title'>
    & { acts?: Maybe<Array<Maybe<Pick<Act, 'id' | 'title' | 'menuTitle' | '_slug'>>>>, menuProductsRedirect?: Maybe<Pick<HomePageMenuProductsRedirect, 'id' | 'title' | 'subtitle'>>, homeRedirect?: Maybe<Pick<HomePageHomeRedirect, 'id' | 'title' | 'subtitle'>>, outroLink?: Maybe<Pick<HomePageOutroLink, 'id' | 'label' | 'url'>>, products?: Maybe<Array<Maybe<(
      Pick<Product, 'category' | 'description' | 'displayTitle' | 'range' | 'id' | 'title' | 'url'>
      & { image?: Maybe<(
        Pick<ProductImage, 'alt' | 'id'>
        & { data?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
      )> }
    )>>> }
  )> };

export type GetLanguageSwitcherQueryVariables = Exact<{
  status?: InputMaybe<ContentStatus>;
  variants?: InputMaybe<Array<InputMaybe<HomePageVariantSelection>> | InputMaybe<HomePageVariantSelection>>;
}>;


export type GetLanguageSwitcherQuery = { languageSwitcher?: Maybe<Pick<HomePage, 'id' | 'languageSwitcherTitle' | 'languageSwitcherShipping' | 'languageSwitcherCountry'>> };

export type ActFragment = Pick<Act, 'id' | 'title' | 'menuTitle' | '_slug'>;

export type ProductFragment = (
  Pick<Product, 'category' | 'description' | 'displayTitle' | 'range' | 'id' | 'title' | 'url'>
  & { image?: Maybe<(
    Pick<ProductImage, 'alt' | 'id'>
    & { data?: Maybe<Pick<MediaFile, 'id' | 'metaData'>> }
  )> }
);

export const ActFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Act"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Act"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"menuTitle"}},{"kind":"Field","name":{"kind":"Name","value":"_slug"}}]}}]} as unknown as DocumentNode;
export const ProductFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayTitle"}},{"kind":"Field","name":{"kind":"Name","value":"range"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode;
export const GetActDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActVariantSelection"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"act"},"name":{"kind":"Name","value":"GetAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Act"}},{"kind":"Field","name":{"kind":"Name","value":"scenes"}}]}}]}},...ActFragmentDoc.definitions]} as unknown as DocumentNode;

export function useGetActQuery(options: Omit<Urql.UseQueryArgs<never, GetActQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetActQuery>({ query: GetActDocument, ...options });
};
export const GetGlobalSeoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGlobalSEO"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getHomePageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HomePageVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"seo"},"name":{"kind":"Name","value":"GetHomePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getHomePageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ogDescription"}},{"kind":"Field","name":{"kind":"Name","value":"ogTitle"}},{"kind":"Field","name":{"kind":"Name","value":"shareImg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metaData"}},{"kind":"Field","name":{"kind":"Name","value":"_slug"}}]}}]}}]}}]} as unknown as DocumentNode;

export function useGetGlobalSeoQuery(options: Omit<Urql.UseQueryArgs<never, GetGlobalSeoQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetGlobalSeoQuery>({ query: GetGlobalSeoDocument, ...options });
};
export const GetHomePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHomePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HomePageVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"page"},"name":{"kind":"Name","value":"GetHomePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Act"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuActLabel"}},{"kind":"Field","name":{"kind":"Name","value":"menuProductsRedirect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"homeRedirect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"introStartDescription"}},{"kind":"Field","name":{"kind":"Name","value":"introStartLabel"}},{"kind":"Field","name":{"kind":"Name","value":"introStartTitle"}},{"kind":"Field","name":{"kind":"Name","value":"introTutorialOverline"}},{"kind":"Field","name":{"kind":"Name","value":"introTutorialTitle"}},{"kind":"Field","name":{"kind":"Name","value":"outroLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outroRestartLabel"}},{"kind":"Field","name":{"kind":"Name","value":"outroSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"outroTitle"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productsSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"productsTitle"}},{"kind":"Field","name":{"kind":"Name","value":"productsCTA"}},{"kind":"Field","name":{"kind":"Name","value":"teaserDate"}},{"kind":"Field","name":{"kind":"Name","value":"teaserDescription"}},{"kind":"Field","name":{"kind":"Name","value":"teaserEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"teaserTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},...ActFragmentDoc.definitions,...ProductFragmentDoc.definitions]} as unknown as DocumentNode;

export function useGetHomePageQuery(options: Omit<Urql.UseQueryArgs<never, GetHomePageQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetHomePageQuery>({ query: GetHomePageDocument, ...options });
};
export const GetLanguageSwitcherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLanguageSwitcher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variants"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HomePageVariantSelection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"languageSwitcher"},"name":{"kind":"Name","value":"GetHomePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"variants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variants"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"languageSwitcherTitle"}},{"kind":"Field","name":{"kind":"Name","value":"languageSwitcherShipping"}},{"kind":"Field","name":{"kind":"Name","value":"languageSwitcherCountry"}}]}}]}}]} as unknown as DocumentNode;

export function useGetLanguageSwitcherQuery(options: Omit<Urql.UseQueryArgs<never, GetLanguageSwitcherQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetLanguageSwitcherQuery>({ query: GetLanguageSwitcherDocument, ...options });
};